// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"9905f4bb","413":"9129a8f3","453":"670e15c7"}[chunkId] + ".chunk.js";
};